// 赠品活动
import promoActivityApi from './promoActivityApi';

export default {
  ...promoActivityApi,
};
